import uniqueId from '@form-create/utils/lib/unique';
import { makeOptionsRule } from '../../utils/index';
import { makeRequiredRule } from '../../utils';
var label = '选择器';
var name = 'select';
export default {
  icon: 'iconfont iconxuanzeqi',
  label: label,
  name: name,
  rule: function rule() {
    return {
      type: name,
      field: uniqueId(),
      title: label,
      info: '',
      effect: {
        fetch: ''
      },
      props: {},
      options: [{
        value: '选项1',
        label: '选项1'
      }, {
        value: '选项2',
        label: '选项2'
      }],
      checkType: 0
    };
  },
  props: function props() {
    return [makeOptionsRule('options'), makeRequiredRule()];
  },
  basic: function basic() {}
};